import { cn as e } from "../lib/utils.js";
import t from "../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import { dampened as r } from "./transitions.js";
import * as i from "react";
import { jsx as a } from "react/jsx-runtime";
import { motion as o, useReducedMotion as s } from "motion/react";
//#region src/motion/reveal.tsx
var c = [
	"delay",
	"distance",
	"whileInView",
	"once",
	"amount",
	"className",
	"children"
], l = i.forwardRef((i, l) => {
	let { delay: u = 0, distance: d = 10, whileInView: f = !1, once: p = !0, amount: m = .2, className: h, children: g } = i, _ = t(i, c);
	if (s()) return /* @__PURE__ */ a("div", n(n({
		ref: l,
		className: e(h)
	}, _), {}, { children: g }));
	let v = {
		opacity: 0,
		y: d
	}, y = {
		opacity: 1,
		y: 0
	}, b = n(n({}, r), {}, { delay: u });
	return /* @__PURE__ */ a(o.div, n(n(n({
		ref: l,
		className: e(h),
		initial: v
	}, f ? {
		whileInView: y,
		viewport: {
			once: p,
			amount: m
		}
	} : { animate: y }), {}, { transition: b }, _), {}, { children: g }));
});
l.displayName = "Reveal";
//#endregion
export { l as Reveal };

//# sourceMappingURL=reveal.js.map